/**
 * Shared mutable ref for blueprint graph state.
 * BlueprintEditor writes here on every change.
 * AvatarModel reads here every frame in useFrame().
 *
 * Module-level ref avoids prop drilling and React re-render overhead on the hot path.
 */
export const graphState = {
  nodes: [],
  edges: [],
}

// Debug: expose on window so we can inspect from the console / Playwright
// (symmetric with faceGraphState.js → window.__FACE_GRAPH_STATE__).
if (typeof window !== 'undefined') {
  window.__BODY_GRAPH_STATE__ = graphState
}
